import { ControlledInputProps } from "@vixi/types";
import { useCallback, useRef } from "react";

interface UseFileInputProps extends ControlledInputProps<File[]> {
  multiple?: boolean;
}

export const useFileInput = ({ multiple, value: files, onChange, onBlur }: UseFileInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const appendToFileList = useCallback(
    (fileList: FileList | null) => {
      if (!fileList) return;

      const prevFiles = files || [];
      const newFiles = multiple ? prevFiles.concat(Array.from(fileList)) : Array.from(fileList);
      onChange(newFiles);
    },
    [files, multiple, onChange],
  );

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    appendToFileList(fileList);
  };

  const handleRemoveFile = (index: number) => {
    if (!files) return;

    if (inputRef.current) {
      inputRef.current.value = "";
      onBlur();
    }

    files?.splice(index, 1);
    const newFiles = [...files];
    onChange(newFiles);
  };

  return {
    inputRef,
    handleFileChange,
    handleRemoveFile,
    appendToFileList,
  };
};
